import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3bc356b0"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createTextVNode(" 重置 ")
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" 查询")
const _hoisted_3 = { style: {"margin-bottom":"20px","text-align":"right"} }
const _hoisted_4 = /*#__PURE__*/_createTextVNode("同步Erp数据")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("新增用户")
const _hoisted_6 = { class: "roles" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode("离职")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("编辑")
const _hoisted_9 = /*#__PURE__*/_createTextVNode("删除")

import { reactive, ref, unref, onMounted } from 'vue';
import { ElButton, ElTag } from 'element-plus';
import { GbTables } from '@/components/GbTables';
import { useGbTable } from '@/hooks/useGbTable';
import { useDictionary } from '@/store/dictionary.store';
import { DeleteuserApi, GetuserListApi } from '../../../apis/basics/users/apis';
import { TableColumn } from '@/components/GbTables/GbTablesTypes';
import { userSearchDto, userDeletDto } from '../../../apis/basics/users/module';
import UserDialog from './components/userEditorDialog.vue';
import ErpAsyncDialog from './components/erpUserAsyncDialog.vue';

import moment from 'moment';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const writerRef = ref<ComponentRef<typeof UserDialog>>();
const erpAsyncRef = ref<ComponentRef<typeof ErpAsyncDialog>>();

const { getName } = useDictionary();

const state = reactive({
	loading: false,
	search: {} as any,
	paged: { current: 1, page_size: 20 },
});

/* GbTable 配置 */
const { register, tableObject, methods } = useGbTable<userSearchDto>({
	getListApi: GetuserListApi,
	delListApi: DeleteuserApi,
	response: { data: 'data', total: 'total' },
});

/* 数据Table绑定设置 */
const tabColumns = reactive<TableColumn[]>([
	{ field: 'account', label: '登录账号', columnWidth: '140' },
	{ field: 'user_code', label: '员工工号(Erp)', columnWidth: '120' },
	{ field: 'user_name', label: '员工姓名', columnWidth: '120' },
	{ field: 'sex', label: '性别', columnWidth: '80', align: 'center' },
	{ field: 'mobile', label: '联系方式', columnWidth: '120' },
	{ field: 'roles', label: '用户角色' },
	{ field: 'status', label: '状态', columnWidth: '80', align: 'center' },
	{ field: 'created_time', label: '创建时间', columnWidth: '120', align: 'center', fixed: 'right' },
	{ field: 'action', width: '120px', label: '操作', fixed: 'right', align: 'center' },
]);

/* 按钮操作 */
const actions = {
	search: () => {
		const searchInput = Object.assign({}, state.search, state.paged);
		methods.setSearchParams(searchInput);
	},
	reSetSearch: () => {
		state.search = {};
		methods.resetParams(state.search);
	},
	create: () => {
		unref(writerRef)?.create();
	},

	modify: (rowId: string) => {
		unref(writerRef)?.editor(rowId);
	},

	deletes: async (row: any) => {
		const deleteData: userDeletDto = { id: row.id, revision: row.revision };
		await methods.deleteRows(deleteData);
	},
	erpAsync: () => {
		unref(erpAsyncRef)?.openDialog();
	},
};

onMounted(async () => {
	tableObject.pageSize = 20;
	actions.search();
});

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_button_group = _resolveComponent("el-button-group")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_card = _resolveComponent("el-card")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_el_card, {
      shadow: "never",
      "body-style": { paddingBottom: '0' }
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_form, {
          inline: true,
          model: _unref(state).search,
          class: "demo-form-inline",
          size: "small"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, {
              "label-width": '80px',
              label: "工号"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _unref(state).search.user_code,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(state).search.user_code) = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              "label-width": '80px',
              label: "姓名"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _unref(state).search.user_name,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(state).search.user_name) = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              "label-width": '80px',
              label: "账户类型"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  modelValue: _unref(state).search.user_type,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(state).search.user_type) = $event)),
                  class: "w100p",
                  clearable: ""
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_option, {
                      label: "普通用户",
                      value: 0
                    }),
                    _createVNode(_component_el_option, {
                      label: "虚拟用户",
                      value: 1
                    }),
                    _createVNode(_component_el_option, {
                      label: "其他",
                      value: 99
                    }),
                    _createVNode(_component_el_option, {
                      label: "管理员",
                      value: 999
                    }),
                    _createVNode(_component_el_option, {
                      label: "超级管理员",
                      value: 1000
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, null, {
              default: _withCtx(() => [
                _createVNode(_component_el_button_group, null, {
                  default: _withCtx(() => [
                    _createVNode(_unref(ElButton), {
                      icon: "Refresh",
                      onClick: actions.reSetSearch
                    }, {
                      default: _withCtx(() => [
                        _hoisted_1
                      ]),
                      _: 1
                    }, 8, ["onClick"]),
                    _createVNode(_unref(ElButton), {
                      type: "primary",
                      icon: "Search",
                      onClick: actions.search
                    }, {
                      default: _withCtx(() => [
                        _hoisted_2
                      ]),
                      _: 1
                    }, 8, ["onClick"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model"])
      ]),
      _: 1
    }),
    _createVNode(_component_el_card, {
      shadow: "never",
      style: {"margin-top":"10px"}
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_unref(ElButton), {
            size: "small",
            type: "warning",
            onClick: actions.erpAsync
          }, {
            default: _withCtx(() => [
              _hoisted_4
            ]),
            _: 1
          }, 8, ["onClick"]),
          _createVNode(_unref(ElButton), {
            size: "small",
            type: "primary",
            onClick: actions.create
          }, {
            default: _withCtx(() => [
              _hoisted_5
            ]),
            _: 1
          }, 8, ["onClick"])
        ]),
        _createVNode(_unref(GbTables), {
          pageSize: _unref(tableObject).pageSize,
          "onUpdate:pageSize": _cache[3] || (_cache[3] = ($event: any) => ((_unref(tableObject).pageSize) = $event)),
          currentPage: _unref(tableObject).currentPage,
          "onUpdate:currentPage": _cache[4] || (_cache[4] = ($event: any) => ((_unref(tableObject).currentPage) = $event)),
          columns: _unref(tabColumns),
          data: _unref(tableObject).tableList,
          loading: _unref(tableObject).loading,
          pagination: { total: _unref(tableObject).total },
          onRegister: _unref(register)
        }, {
          joined_date: _withCtx(({ row }) => [
            _createElementVNode("span", null, _toDisplayString(row.joined_date ? _unref(moment)(row.joined_date).format('YYYY/MM/DD HH:mm') : '-'), 1)
          ]),
          created_time: _withCtx(({ row }) => [
            _createElementVNode("span", null, _toDisplayString(_unref(moment)(row.created_time).format('YYYY/MM/DD HH:mm')), 1)
          ]),
          roles: _withCtx(({ row }) => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(row.roles, (role) => {
              return (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _createVNode(_unref(ElTag), { size: "small" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(role), 1)
                  ]),
                  _: 2
                }, 1024)
              ]))
            }), 256))
          ]),
          sex: _withCtx(({ row }) => [
            _createVNode(_unref(ElTag), {
              type: "info",
              size: "small"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(getName)('sex', row.sex)), 1)
              ]),
              _: 2
            }, 1024)
          ]),
          status: _withCtx(({ row }) => [
            (row.status == '2')
              ? (_openBlock(), _createBlock(_unref(ElTag), {
                  key: 0,
                  type: "success",
                  size: "small"
                }, {
                  default: _withCtx(() => [
                    _hoisted_7
                  ]),
                  _: 1
                }))
              : (_openBlock(), _createBlock(_unref(ElTag), {
                  key: 1,
                  type: "warning",
                  size: "small"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(getName)('user_status', row.status)), 1)
                  ]),
                  _: 2
                }, 1024))
          ]),
          action: _withCtx(({ row }) => [
            _createVNode(_unref(ElButton), {
              size: "small",
              type: "success",
              link: "",
              onClick: ($event: any) => (actions.modify(row.id))
            }, {
              default: _withCtx(() => [
                _hoisted_8
              ]),
              _: 2
            }, 1032, ["onClick"]),
            _createVNode(_unref(ElButton), {
              size: "small",
              type: "danger",
              link: "",
              onClick: ($event: any) => (actions.deletes(row))
            }, {
              default: _withCtx(() => [
                _hoisted_9
              ]),
              _: 2
            }, 1032, ["onClick"])
          ]),
          _: 1
        }, 8, ["pageSize", "currentPage", "columns", "data", "loading", "pagination", "onRegister"])
      ]),
      _: 1
    }),
    _createVNode(UserDialog, {
      ref_key: "writerRef",
      ref: writerRef,
      onRefresh: actions.search
    }, null, 8, ["onRefresh"]),
    _createVNode(ErpAsyncDialog, {
      ref_key: "erpAsyncRef",
      ref: erpAsyncRef,
      onRefresh: actions.search
    }, null, 8, ["onRefresh"])
  ], 64))
}
}

})